import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	Button, Col, Grid, Radio, Row,
} from 'react-bootstrap';
import { isEqual } from 'lodash';
import utils from '@utils';
import { QuickPaySummary } from './components';

class InvoiceInfo extends Component {
	shouldComponentUpdate({ timeZoneId, sendEmailReceipt }) {
		const lastProps = this.props;

		return (
			!isEqual(timeZoneId, lastProps.timeZoneId)
			|| !isEqual(sendEmailReceipt, lastProps.sendEmailReceipt)
		);
	}

	render() {
		const {
			invoice, timeZoneId, sendEmailReceipt, updateData, onSubmit,
		} = this.props;

		const {
			Id,
			ClientName,
			InvoiceDate,
			JobLocation,
			Coordinator,
			OfficerName,
		} = invoice;

		return (
			<Fragment>
				<div className="margin-top-30">
					<Grid>
						<Row>
							<Col md={7} sm={12}>
								<div className="margin-bottom-30">
									<span className="font-size-24 font-bold">New Invoice</span>
								</div>

								<div className="margin-top-30 margin-bottom-30 visible-sm-block visible-xs-block">
									<div className="text-center">
										<div className="margin-bottom-20">
											<Button
												bsStyle="primary"
												className="form-control height-54 font-size-16"
												onClick={() => onSubmit(2)}
											>
												Pay Now
											</Button>
										</div>
										<div>
											<span className="color-gray-shuttle">Already have an account? </span>
											<a href="/login">Sign In now</a>
										</div>
									</div>
								</div>

								<div className="quickpay-invoice-info">
									<div className="margin-top-30 margin-bottom-20 position-relative">
										<div className="hidden-xs" id="quickpay-title-icon">
											<i className="rkf rkf-invoice text-primary font-size-26 margin-right-10" />
										</div>
										<div className="flex flex-align-items-top">
											<div className="visible-xs-block">
												<i className="rkf rkf-invoice text-primary font-size-20 margin-right-5" />
											</div>
											<div className="color-gray-shuttle">
												Below is a summary of your off-duty services.
											</div>
										</div>
									</div>

									<div className="invoice-table-header">
										Invoice #
										{ Id }
									</div>

									<div className="margin-bottom-30">
										<Row className="padding-top-7 padding-bottom-7">
											<Col xs={3}>Client:</Col>
											<Col xs={9}>{ ClientName }</Col>
										</Row>
										<Row className="bg-gray-whisper padding-top-7 padding-bottom-7">
											<Col xs={3}>Date:</Col>
											<Col xs={9}>{ utils.parseUTCDateToTimeZone(InvoiceDate, timeZoneId).format('MMMM DD, YYYY') }</Col>
										</Row>
										<Row className="padding-top-7 padding-bottom-7">
											<Col xs={3}>Location:</Col>
											<Col xs={9}>{ JobLocation }</Col>
										</Row>
										<Row className="bg-gray-whisper padding-top-7 padding-bottom-7">
											<Col xs={3}>Agency:</Col>
											<Col xs={9}>{ Coordinator ? Coordinator.Name : '' }</Col>
										</Row>
										<Row className="padding-top-7 padding-bottom-7">
											<Col xs={3}>Officer:</Col>
											<Col xs={9}>{ OfficerName }</Col>
										</Row>
										<Row className="padding-top-25 flex flex-align-items-center">
											<Col xs={3}>Receipt:</Col>
											<Col xs={9}>
												<div className="flex flex-align-items-center">
													<div>
														<Radio
															name="receipt"
															onChange={() => updateData('sendEmailReceipt', false)}
															checked={!sendEmailReceipt}
															className="margin-0"
														>
															None
														</Radio>
													</div>
													<div className="margin-left-20">
														<Radio
															name="receipt"
															onChange={() => updateData('sendEmailReceipt', true)}
															checked={sendEmailReceipt}
															className="margin-0"
														>
															Email
														</Radio>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</div>

								<div className="hidden-sm hidden-xs">
									<div className="flex flex-align-items-center flex-justify-content-end margin-top-30 margin-bottom-30">
										<div className="margin-right-20">
											<span className="color-gray-shuttle">Already have an account? </span>
											<a href="/login">Sign In now</a>
										</div>
										<div>
											<Button
												bsStyle="primary"
												className="width-166 height-54 font-size-16"
												onClick={() => onSubmit(2)}
											>
												Pay Now
											</Button>
										</div>
									</div>
								</div>
							</Col>
							<Col md={1} sm={12} />
							<Col md={4} sm={12}>
								<QuickPaySummary
									invoice={invoice}
									timeZoneId={timeZoneId}
									type="1"
									status="unpaid"
								/>
							</Col>
						</Row>
					</Grid>
				</div>

				<div className="margin-top-30 margin-bottom-50 visible-sm-block visible-xs-block">
					<Grid className="text-center">
						<div className="margin-bottom-20">
							<Button
								bsStyle="primary"
								className="form-control height-54 font-size-16"
								onClick={() => onSubmit(2)}
							>
								Pay Now
							</Button>
						</div>
						<div>
							<span className="color-gray-shuttle">Already have an account? </span>
							<a href="/login">Sign In now</a>
						</div>
					</Grid>
				</div>
			</Fragment>
		);
	}
}

InvoiceInfo.propTypes = {
	invoice          : PropTypes.object,
	onSubmit         : PropTypes.func.isRequired,
	sendEmailReceipt : PropTypes.bool,
	timeZoneId       : PropTypes.string,
	updateData       : PropTypes.func.isRequired,
};

InvoiceInfo.defaultProps = {
	invoice          : {},
	sendEmailReceipt : false,
	timeZoneId       : '',
};

export default InvoiceInfo;
